import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoon, faSun } from "@fortawesome/free-solid-svg-icons";

const ToggleButton = styled.button`
  display: grid;
  place-items: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 1px solid var(--border);
  background: var(--bg-elevated);
  color: var(--text-primary);
  cursor: pointer;
  transition: border-color 0.2s ease, color 0.2s ease, transform 0.2s ease;

  &:hover {
    color: var(--accent);
    border-color: var(--accent);
  }

  &:active {
    transform: scale(0.94);
  }
`;

function ThemeToggle({ theme, onToggle }) {
  const isDark = theme === "dark";
  return (
    <ToggleButton
      type="button"
      onClick={onToggle}
      aria-label={isDark ? "Switch to light theme" : "Switch to dark theme"}
      aria-pressed={isDark}
    >
      <FontAwesomeIcon icon={isDark ? faSun : faMoon} fontSize={13} />
    </ToggleButton>
  );
}

export default ThemeToggle;
